import { ClientEvents } from "discord.js";
import { IEvent } from "../typings/events";

export class Event<T extends keyof ClientEvents> implements IEvent<T> {
    constructor(options: IEvent<T>) {
        Object.assign(this, options);
    }
    name: T;
    readableName?: string;
    enabled?: boolean;
    once?: boolean;
    run: (...args: ClientEvents[T]) => any | Promise<any>;
}